import React, { useState, useEffect } from "react";
import { usePagination, useValidation } from "../hooks";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { SCREEN_IDS } from "../components/FullComponent.js";
import { fullDataPiece } from "../services/ConnectDataBase";
import { updateInfoData } from "../redux/reducers";
import { getArrayInfoDataUpdate } from "../services/Functions";
import { getWorkLoad, getTotalTimeToday } from "../services/ConnectDataBase";
import { typeConnect, backgroundColor2 } from "../constants/Constants";
import { formatTime, formatDateTime } from "../services/Functions.js";
import { useNavigation } from "@react-navigation/native";
import { translateText } from "../translations/translationService";
import { OPERARIO_SCREEN_COLORS } from "../style/colors.js";
import { notify } from "../services/ui/notify";

export default function OperarioScreen({ route }) {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const operario = route?.params?.operario;
  const lang = useSelector((state) => state.lang.value);
  const currentScreenId = SCREEN_IDS.OPERATION_PANEL;
  const usuario = operario || useSelector((state) => state.user.name);

  const [totalTime, setTotalTime] = useState(0);
  const tiempoEsperado = 24300; // 6 horas y 45 minutos en segundos
  const tiempoRestante = Math.max(0, tiempoEsperado - totalTime);

  // Hook de paginación
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePagination(0, 25);

  const formatNumberWithLeadingZero = (number) => {
    return number < 10 ? `0${number}` : `${number}`;
  };

  const formatTimeFromSeconds = (totalSeconds) => {
    const horas = Math.floor(totalSeconds / 3600);
    const minutos = Math.floor((totalSeconds % 3600) / 60);
    const segundos = totalSeconds % 60;
    return `${formatNumberWithLeadingZero(horas)}:${formatNumberWithLeadingZero(
      minutos
    )}:${formatNumberWithLeadingZero(segundos)}`;
  };

  const tiempoFormateado = formatTimeFromSeconds(tiempoRestante);
  const tiempoHoyFormateado = formatTimeFromSeconds(totalTime);

  const [moData, setMoData] = useState([]);

  useEffect(() => {
    workLoad();
    totalTimeWork();
  }, []);

  // Hook de validación
  const { validateData, handleSubmitCode: validateAndSubmit } = useValidation({
    autoDispatch: true,
    validationType: 2
  });

  const handleSubmitCode = async (code) => {
    try {
      const fullData = await validateAndSubmit(code);

      if (code) {
        if (fullData && fullData.mo) {
          if (code.replace("'", "-") !== fullData.mo) {
            notify.warn("El código introducido no es correcto.");
          } else {
            navigation.navigate("Info", { data: fullData });
          }
        } else {
          console.log("La propiedad 'mo' no existe en fullData.");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };


  const workLoad = async () => {
    try {
      const carga = await getWorkLoad(usuario, currentScreenId, typeConnect[0]);
      if (carga) {
        setMoData(carga);
      } else {
        setMoData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const totalTimeWork = async () => {
    try {
      const tiempo = await getTotalTimeToday(
        usuario,
        currentScreenId,
        typeConnect[0]
      );
      if (tiempo && tiempo.length > 0 && tiempo[0].tiempo_total) {
        setTotalTime(parseInt(tiempo[0].tiempo_total));
      } else {
        setTotalTime(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h5' align='center' gutterBottom>
        Panel de Operario : {usuario}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
          padding: 1,
          marginBottom: 2,
        }}>
        <Typography variant='body1' sx={{ color: "black", marginRight: 2 }}>
          Total Diario: {tiempoHoyFormateado}
        </Typography>
        <Typography variant='body1' sx={{ color: "black", marginRight: 2 }}>
          Restante: {tiempoFormateado}
        </Typography>
        <Typography variant='body1' sx={{ color: "black" }}>
          Esperado: 06:45:00
        </Typography>
      </Box>
      {moData.length === 0 ? (
        <Typography variant='h6' align='center' sx={{ marginTop: 4 }}>
          No tiene MOs asignadas
        </Typography>
      ) : (
        <>
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "45vh",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}>
            <Table size='small' stickyHeader>
              <TableHead sx={{ backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                <TableRow>
                  <TableCell
                    align='center'
                    sx={{ color: "black", backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                    MO
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ color: "black", backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                    Tiempo
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ color: "black", backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                    Cantidad
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ color: "black", backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                    F. Entrega
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{ color: "black", backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
                    Empezar
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {moData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align='center'>{item.mo}</TableCell>
                      <TableCell align='center'>{item.tiempo_total}</TableCell>
                      <TableCell align='center'>{item.cantidad}</TableCell>
                      <TableCell align='center'>
                        {item.fechaentrega
                          ? formatDateTime(item.fechaentrega)
                          : "Sin fecha"}
                      </TableCell>
                      <TableCell align='center'>
                        {item.cantidad > item.cantidad_terminada && (
                          <Button
                            variant='contained'
                            onClick={() => handleSubmitCode(item.mo)}
                            sx={{
                              backgroundColor: backgroundColor2,
                              "&:hover": {
                                backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_NEUTRAL,
                              },
                            }}>
                            Ir
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component='div'
            count={moData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </>
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: 2,
          marginTop: 2,
        }}>
        <Button
          variant='contained'
          sx={{
            marginRight: 2,
            backgroundColor: backgroundColor2,
            "&:hover": { backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_HOVER },
          }}
          onClick={() => {
            navigation.navigate("Scan");
          }}>
          {translateText("Escanear", lang)}
        </Button>
        <Button
          variant='contained'
          sx={{
            backgroundColor: backgroundColor2,
            "&:hover": { backgroundColor: OPERARIO_SCREEN_COLORS.BACKGROUND_HOVER },
          }}
          onClick={() => {
            navigation.navigate("Screen work");
          }}>
          {translateText("Multiple MOs", lang)}
        </Button>
      </Box>
    </Box>
  );
}
